import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Clock, Facebook, Instagram } from 'lucide-react';
import { companyInfo } from '../data/mock';

// X (Twitter) Icon
const XIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#484237] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_home-improvement-pro/artifacts/tjia1iyl_Massimo_logo%202.png" 
                alt="Massimo Home Improvement" 
                className="h-12 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-sm text-gray-300 leading-relaxed">
              Transforming projects into homes with quality, design, and high-standard finishes.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#D7AC78]">Quick Links</h3>
            <ul className="space-y-2">
              {[
                { name: 'Home', path: '/' },
                { name: 'About', path: '/sobre' },
                { name: 'Services', path: '/servicos' },
                { name: 'Gallery', path: '/instagram' },
                { name: 'Contact', path: '/contato' }
              ].map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    className="text-sm text-gray-300 hover:text-[#D7AC78] transition-colors duration-300"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#D7AC78]">Services</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Residential Renovations</li>
              <li>Commercial Renovations</li>
              <li>Custom Design</li>
              <li>Premium Finishes</li>
              <li>Project Management</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#D7AC78]">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-[#D7AC78] mt-0.5 flex-shrink-0" />
                <a href={`mailto:${companyInfo.contact.email}`} className="text-sm text-gray-300 hover:text-[#D7AC78] transition-colors">
                  {companyInfo.contact.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#D7AC78] mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-300">{companyInfo.contact.address}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Clock size={18} className="text-[#D7AC78] mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-300">{companyInfo.contact.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Media & Copyright */}
        <div className="pt-8 border-t border-gray-600">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} Massimo Home Improvement. All rights reserved.
            </p>
            <div className="flex space-x-4">
              <a
                href={companyInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#728481] rounded-lg flex items-center justify-center hover:bg-[#D7AC78] transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href={companyInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#728481] rounded-lg flex items-center justify-center hover:bg-[#D7AC78] transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href={companyInfo.social.x}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#728481] rounded-lg flex items-center justify-center hover:bg-[#D7AC78] transition-colors duration-300"
                aria-label="X (Twitter)"
              >
                <XIcon size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
